module.exports = __webpack_public_path__ + "img/22.8ccdd9ce.svg";